/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../Upper Footer Slider/UpperFooterSlider.css";

import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";

export default function UpperFooterSlider() {
  const [swiper, setSwiper] = useState(null);
  const swiperRef = useRef(null);

  const [subscribeEmail , setsubscribeEmail] = useState("")
  const [subscribeSubmit , setsubscribeSubmit] = useState(false)
  const [checkemail , setcheckemail] = useState(false)

  function SubscribeNow(e) {
    e.preventDefault();
    setsubscribeSubmit(true) 
    if (subscribeEmail && checkemail) {
      console.log("Email is valid. Ready to submit form!");
   
      PostService(API_URL.SubscribeNow , {email:subscribeEmail}).then((res)=>{
        console.log(res)
        if (res?.data?.status) {
          setsubscribeEmail("")
          setcheckemail(false)
          setsubscribeSubmit(false)
        }
      }) 
  }
}

  const validateEmail = (email) => { 
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    console.log(re)
    console.log(re.test(email))
    return re.test(email);
  };
  return (
    <div>
      {/* blog-area-start */}
      <div className="tp-blog__area p-relative pink-bg-add pt-80 pb-20">
        <div className="container text-center  ">
          <div className="row text">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <h4 className="text-left second head">
                Get inspired to <span className="color-inner">Create! </span>{" "}
              </h4>
              <p className="head-para-center">
                See what our customers have created and shared so you can get
                inspired to create your own, today!
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* blog-area-end */}
      {/* instagram-area-start */}

      <div className="tp-instagram-2__area as pb-80">
        <div className="container-fluid g-0">
          <div className="tp-instagram-2-warpper">
            <div className="swiper-container tp-instagram-2-active ">
              <div className="">
                <Swiper
                  slidesPerView={4}
                  // pagination={{
                  //   clickable: true,
                  // }}
                  modules={[Autoplay]}
                  loop
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  className="mySwiper"
                >
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-1.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-2.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-3.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-4.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-5.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-2.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-3.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                  <div className="swiper-slide">
                    <SwiperSlide>
                      <div className="tp-instagram-2__thumb">
                        <a href="#">
                          <img
                            src="assets/img/gallery/gallery-2-4.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* instagram-area-end */}

      <section className="subscribe pt-50 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="tp-footer-2__top-box">
                <h4 className="tp-footer-2__top-title">
                  Subscribe <span className="color-inner">Now </span>
                </h4>
                <p>
    Get the latest updates on new features, exclusive offers, and creative inspiration delivered to your inbox.
  </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 ">
            {/* <form >
              <div className="me-0 tp-footer-2__form"> 
                  <input type="email" placeholder="Email Address" className={!checkemail && subscribeSubmit  ?'border_error' : ""} value={subscribeEmail} onChange={(e)=>{setsubscribeEmail(e.target.value);setcheckemail(validateEmail(e.target.value))}}/> 
              </div>
              <div className="tp-header__chat-box btn-show ms-0 pr-15">
                <button className="tp-btn-lg large head" onClick={SubscribeNow} >
                  Subscribe NOW
                </button>
              </div>
              </form> */}
              <div className="d-flex"> 
                <div className="col-8 "> 
                  <input type="email" placeholder="Email Address" style={{height:'40px'}} className={!checkemail && subscribeSubmit  ?'border_error' : ""} value={subscribeEmail} onChange={(e)=>{setsubscribeEmail(e.target.value);setcheckemail(validateEmail(e.target.value))}}/> 
              </div>  
                <div className="col-4  ">
                <button className="tp-btn-lg large head" onClick={SubscribeNow} >
                  Subscribe Now
                </button>
              </div>  
              </div> 
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
